import { env } from 'config/env';
import type { ResourcesConfig } from 'aws-amplify';

const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: env.VITE_USER_POOL_ID,
      userPoolClientId: env.VITE_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: env.VITE_OAUTH_DOMAIN,
          scopes: ['phone', 'email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [env.VITE_REDIRECT_URL],
          redirectSignOut: [env.VITE_REDIRECT_URL],
          responseType: 'code',
        },
      },
    },
  },
};

export default amplifyConfig;
